// src/components/home/PartnersSection.js
import React from 'react';
import { motion } from 'framer-motion';
import Section from '../common/Section';
import Heading from '../common/Heading';

const PartnersSection = () => {
  const partners = [
    {
      name: 'Engineers Without Borders – Denmark',
      logo: '/images/partners/Engineers Without Borders - Denmark.png',
      placeholder: 'EWB-DK'
    },
    {
      name: 'Civil Society in Development – Denmark',
      logo: '/images/partners/Civil Society in Development - Denmark.jpg',
      placeholder: 'CSID-DK'
    },
    {
      name: 'Sierra Leone Institution of Engineers',
      logo: '/images/partners/slie.png',
      placeholder: 'SLIE'
    },
    {
      name: 'Engineers for Change Sierra Leone',
      logo: '/images/partners/efcsl.png',
      placeholder: 'EFCSL'
    },
    {
      name: 'Engineering Society - FBC',
      logo: '/images/partners/Engineering Society - FBC.png',
      placeholder: 'SLWE'
    },
    {
      name: 'Sierra Leone Women Engineers',
      logo: '/images/partners/slwe.png',
      placeholder: 'SLWE'
    },
    {
      name: 'Freetown Innovation Lab',
      logo: '/images/partners/freetown-poly.png',
      placeholder: 'FP'
    }
  ];
  
  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };
  
  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };
  
  return (
    <Section background="gray" padding="normal" className="border-t border-gray-200">
      <div className="text-center mb-12">
        <Heading level={2} align="center" className="mb-4">
          Our Partners & Collaborators
        </Heading>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto">
          We collaborate with leading organizations to provide the best training experience
        </p>
      </div>
      
      <motion.div
        className="flex flex-wrap justify-center items-center gap-8"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        {partners.map((partner, index) => (
          <motion.div
            key={index}
            variants={itemVariants}
            className="bg-white py-6 px-8 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 min-w-[200px] flex items-center justify-center"
          >
            <div className="w-full text-center">
              {/* Logo would be rendered here if available, otherwise placeholder */}
              <div 
                className="h-16 flex items-center justify-center mb-2"
                title={partner.name}
              >
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="max-h-16 max-w-full"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.parentElement.innerHTML = `<div class="bg-primary text-white font-bold text-xl rounded-md p-2 w-full flex items-center justify-center h-16">${partner.placeholder}</div>`;
                  }}
                />
              </div>
              <span className="text-gray-700 font-medium text-sm text-center">
                {partner.name}
              </span>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </Section>
  );
};

export default PartnersSection;